import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'

interface Props {
  title: string
  right: any
  onClick?: () => void
  isSelected?: boolean
  leftSpan?: number
}

const RowSelectedItem: React.ComponentType<Props> = ({
  title,
  right,
  isSelected = false,
  onClick,
  leftSpan = 18,
}) => {
  return (
    <Item className={isSelected ? 'selected' : undefined} onClick={onClick}>
      <Row type="flex" justify="space-between" className="row-item">
        <Col span={leftSpan}>
          <Name>{title}</Name>
        </Col>
        <Col>{right}</Col>
      </Row>
    </Item>
  )
}

const Item = styled.div`
  font-size: 20px;
  border-bottom: 1px solid #e8ebf0;
  height: 56px;
  align-items: center;
  display: flex;
  padding: 0px 16px;
  cursor: pointer;

  &.selected {
    border-radius: 5px;
    border: solid 1px #003168;
  }

  .row-item {
    width: 100%;
  }
`

const Name = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default RowSelectedItem
